import React from 'react';
import { useDispatch } from 'react-redux';
import type { Thread } from '../../api/agentChat/threads/interface';
import { useSelector } from '../store';
import { actions as threadsActions } from './logic';

interface AgentChatThreadsHookState {
  threads: Thread[];
  hasData: boolean;
}

interface AgentChatThreadsHookHandler {
  listThreads: () => void;
  /** Push or replace a thread in the per-dossier cache. Caller does the API. */
  threadUpserted: (thread: Thread) => void;
  /** Drop a thread from the per-dossier cache. */
  threadRemoved: (threadId: string) => void;
}

const EMPTY: Thread[] = [];

export default function useAgentChatThreadsHook(
  dossierId: string
): [AgentChatThreadsHookState, AgentChatThreadsHookHandler] {
  const dispatch = useDispatch();
  const threads = useSelector(
    (s) => s.agentChatThreads.threads[dossierId] ?? EMPTY
  );
  const hasData = useSelector(
    (s) => s.agentChatThreads.threads[dossierId] !== undefined
  );

  const handler = React.useMemo<AgentChatThreadsHookHandler>(
    () => ({
      listThreads: () => {
        dispatch(threadsActions.listThreads(dossierId));
      },
      threadUpserted: (thread) => {
        dispatch(threadsActions.threadUpserted({ dossierId, thread }));
      },
      threadRemoved: (threadId) => {
        dispatch(threadsActions.threadRemoved({ dossierId, threadId }));
      },
    }),
    [dispatch, dossierId]
  );

  return [{ threads, hasData }, handler];
}
